module.exports = __webpack_public_path__ + "media/images/benefits-thumbup-e5a97897f4301954eb31a272b69f7a9a.svg";